import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { resumeDataInterface } from '../../interfaces/resume';

@Component({
  selector: 'mcrit-gestio-last-projects-fi',
  templateUrl: './last-projects-fi.component.html',
  styleUrls: ['./last-projects-fi.component.css'],
  providers: [ProjectsService]
})
export class LastProjectsFiComponent implements OnInit {
  public activeProjects: Array<any> = [];
  public resumeData: resumeDataInterface = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
        empresa:{totalMCRIT: 0, totalMULTI: 0,  totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};

  public createProject() {this.router.navigate(['project', 'new']);}
  public navigateToProject(project) {this.router.navigate(['project', project.codi]);}
  public requestAddHoursDialog($event, id) {$event.stopPropagation();}
  public viewAllProjects() {this.router.navigate(['projects']);}

  constructor(private projectsService: ProjectsService, private router: Router){}
 
  ngOnInit() {
    this.projectsService.getActive(1000, 0, { //FILTRE DELS TREBALLS QUE ES MOSTREN A INICI (Finalitzats)
      stateFinished: true,
      codi: 'MCRIT_' //No mostra els projectes que comencen per MCRIT_ que són interns
    },//Funció a aplicar. Per defecte LIKE %%
    {
      cnd_codi: 'NOT LIKE'
    },
    { //ORDRE DELS TREBALLS QUE ES MOSTREN A INICI (tematica3, data_aprovacio)
      'data_aprovacio': 'DESC'
    })
    .subscribe(
      projects => {
        this.activeProjects = projects.rows;
        this.resumeData = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
          empresa:{totalMCRIT: 0, totalMULTI: 0, totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};
          this.activeProjects.map(item => {
          if(item.empresa != "Consorci")
            switch(item.ambit_proposta){
             case 'Europa': this.resumeData.ambit.totalEU+=item.pressupost_contractat;this.resumeData.ambit.numEU++;break;
             case 'Internacional': this.resumeData.ambit.totalInt+=item.pressupost_contractat;this.resumeData.ambit.numInt++;break;
             case 'Espanya': this.resumeData.ambit.totalE+=item.pressupost_contractat;this.resumeData.ambit.numE++;break;
             case 'Catalunya': this.resumeData.ambit.totalCAT+=item.pressupost_contractat;this.resumeData.ambit.numCAT++;break;
            };
          switch(item.empresa){
            case 'MCRIT': this.resumeData.empresa.totalMCRIT+=item.pressupost_contractat;this.resumeData.empresa.numMCRIT++;break;
            case 'Multicriteri': this.resumeData.empresa.totalMULTI+=item.pressupost_contractat;this.resumeData.empresa.numMULTI++;break;
            case 'Multicriteri MCRIT AIE': this.resumeData.empresa.totalAIEMULTI+=item.pressupost_contractat;this.resumeData.empresa.numAIEMULTI++;break;
            case 'Ersília': this.resumeData.empresa.totalERSI+=item.pressupost_contractat;this.resumeData.empresa.numERSI++;break;
            case 'Geovincles': this.resumeData.empresa.totalGEO+=item.pressupost_contractat;this.resumeData.empresa.numGEO++;break;
          }
        });
      },
      error => console.log(error)
    );
  }

}
